import React, { useRef, Suspense } from 'react';
import Spinner from 'design-system/Spinner';
import TaskComponent from 'react-scale/components/Task/TaskComponent';
import { ShortcutsProvider } from 'react-scale/hooks/useShortcut';
import ErrorBoundary from 'dashboard/components/SelfServe/TaskSetup/RapidTaskErrorBoundary';

interface TaskUIProps {
  taskProps: any;
  showResponseJson?: boolean;
  fullSize?: boolean;
}

const TaskUITab: React.FC<TaskUIProps> = ({ taskProps, showResponseJson, fullSize }) => {
  const taskRef = useRef<$FIXME>();
  return (
    <ErrorBoundary>
      <Suspense fallback={<Spinner style={{ paddingBottom: '16px' }} />}>
        <div className="component">
          <ShortcutsProvider>
            <TaskComponent
              key={taskProps.task_id}
              taskRef={taskRef}
              taskType={taskProps.type}
              taskProps={taskProps}
              isTaxonomyDisplay={true}
              showResponseJson={showResponseJson}
            />
          </ShortcutsProvider>
        </div>
      </Suspense>
      <style jsx global>{`
        .error {
          padding-bottom: 24px;
        }
        .component {
          height: 540px;
        }
        .component,
        .component .task {
          flex-grow: 1;
          display: flex;
          flex-direction: column;
          min-height: 0;
          min-width: 0;
          overflow: auto;
          height: ${fullSize ? '90%' : 'undefined'};
        }
        .task__splitpane {
          position: relative;
          overflow: auto;
        }
      `}</style>
    </ErrorBoundary>
  );
};

export default TaskUITab;
